export default "data:image/webp;base64,UklGRkAAAABXRUJQVlA4TDMAAAAvJ4AGAFAUgAyUQwVFJVbCzqdAgCiS7UaOACEBsckN+4wV+5+Q9VQx/3rEN/vXU8Ug6wEA"